export enum OscEnvironment {
  Local = 'Local',
  Development = 'Development',
  Staging = 'Staging',
  Production = 'Production',
  Simulator = 'Simulator',
}
